import {announce} from '@github-ui/aria-live'
import {useConvertToDraftMutation} from '@github-ui/mergebox/use-convert-to-draft-mutation'
import {GitPullRequestDraftIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'
import {FailureDialog} from './FailureDialog'
import {useInvalidatePrState} from '../data/use-invalidate-pr-state'
import {PullRequestState} from '../../../types'

export function ConvertToDraftAction() {
  const invalidatePrState = useInvalidatePrState()

  const convertToDraftMutation = useConvertToDraftMutation({
    onSuccess: () => {
      announce('Pull request converted to draft')
      invalidatePrState(PullRequestState.Draft)
    },
  })

  return (
    <>
      <ActionList.Item loading={convertToDraftMutation.isPending} onSelect={() => convertToDraftMutation.mutate()}>
        <ActionList.LeadingVisual>
          <GitPullRequestDraftIcon />
        </ActionList.LeadingVisual>
        Convert to draft
      </ActionList.Item>

      {convertToDraftMutation.isError && (
        <FailureDialog
          title="Failed to convert to draft"
          message="An error occurred while converting this pull request to a draft. Please try again."
          details={convertToDraftMutation.error.message}
          onRetry={() => convertToDraftMutation.mutate()}
          onDismiss={() => convertToDraftMutation.reset()}
        />
      )}
    </>
  )
}
